module.exports = __webpack_public_path__ + "img/LAPTOP.bb90933e.svg";